<template>
  <v-card>
    <v-card-title primary-title class="py-2">
      <div class="subheading">
        {{ $t("view.commons.records") }}
      </div>
      <v-spacer />
      <v-btn icon @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-fade-transition>
      <v-card-text v-show="view.elem.datatable.visible" class="pt-0">
        <v-layout row wrap>
          <v-flex xs12 sm9>
            <filters ref="filters" @filter="filter" @massupdate="massupdate" />
          </v-flex>
          <v-flex md12>
            <v-data-table
              ref="dataTable"
              item-key="clave"
              class="campana dataTable"
              sort-by="clave"
              :show-select="$userPermission.hasPermission('ROLE_MODIFICAR_MSSCAM')"
              :sort-desc="true"
              :headers="view.elem.datatable.headers"
              :items="view.elem.datatable.data"
              :loading="view.elem.datatable.loading"
              :footer-props="view.elem.datatable.footerprops"
              :must-sort="true"
              :server-items-length="view.elem.datatable.total"
              :options.sync="options"
              :value="selected"
              @toggle-select-all="toggleSelectAll"
              @item-selected="itemSelected">
              <template #top>
                <v-text-field
                  v-model.trim="search"
                  dense
                  clearable
                  hide-details
                  :label="$t('view.commons.search')"
                  append-icon="mdi-magnify"
                  @keydown.enter="refreshSearch"
                  @click:append="refreshSearch"
                  @click:clear="clearSearch" />
              </template>

              <template #footer.prepend>
                <v-navigation-drawer v-if="selectedcomputed">{{ selectedcomputed }} {{ $t("view.commons.selected") }}</v-navigation-drawer>
              </template>

              <template #item.data-table-select="{ isSelected, select }">
                <v-checkbox :input-value="isSelected" hide-details class="pa-0 ma-0" @click="select(!isSelected)" />
              </template>

              <template #item.se="{ item }">
                <div v-if="item.se" class="d-inline-flex align-center">
                  <span>{{ fixSe(item.se) }}</span>
                  <v-chip class="ml-1" dense x-small :color="SE_NEGOCIO_TABLE[item.negocio].color">
                    <strong>{{ item.negocio }}</strong>
                  </v-chip>
                </div>
              </template>

              <template #item.canales="{ item }">
                <div :title="item.canales ? item.canales.replaceAll(',', ', ') : ''" class="btn_tippy">{{ item.canales ? item.canales.replaceAll(",", ",&nbsp;&nbsp;&nbsp; ") : "" }}</div>
              </template>

              <template #item.accion="{ item }">
                <buttons
                  :ref="`dataTableBtn_${item.clave}`"
                  :key="refreshkey"
                  :clave="item.clave"
                  :descripcion="item.descripcion"
                  :showdisable="item.status && $userPermission.hasPermission('ROLE_MODIFICAR_OP')"
                  @edit="edit"
                  @disable="disable"
                  @audit="audit" />
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-fade-transition>

    <!-- Mass Update Modal-->
    <mass-update-modal
      v-show="view.elem.datatable.data && $userPermission.hasPermission('ROLE_MODIFICAR_MSSCAM')"
      ref="massUpdateModal"
      :search="search"
      :headers="view.elem.datatable.headers"
      @refresh="refreshData" />
  </v-card>
</template>

<script>
import Filters from "@/views/operativos/campana/Filters"; /** *******************************/
import CampanaAPI from "@/services/operativos/campana"; /** *******************************/
import Buttons from "@/components/datatable/Buttons"; /** *******************************/
import MassUpdateModal from "@/views/operativos/campana/massupdate/MassUpdateModal"; /** *******************************/
import transform from "@/helpers/server-side-datatable";
import tippy from "tippy.js";
import { disableSwal } from "@/constants/sweet-alerts";
import { handleResponse } from "@/helpers/http-response-handler";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { SE_NEGOCIO_TABLE } from "@/constants/operativos";
import { fixSe } from "@/helpers/form-common";

export default {
  name: "DataTable"
  , components: { Buttons, Filters, MassUpdateModal }
  , data() {
    return {
      options: {}
      , filtros: {}
      , selected: []
      , deselected: []
      , selectall: false
      , search: ""
      , refreshkey: 0
      , SE_NEGOCIO_TABLE
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("view.commons.clave"), align: "left", sortable: true, class: "clave", cellClass: "clave", value: "clave" }
              , { text: this.$t("view.operativos.campana.form.descripcion.th"), align: "left", sortable: true, class: "descripcion", cellClass: "descripcion", value: "descripcion" }
              , { text: this.$t("view.operativos.campana.form.descripcionapp.th"), align: "left", sortable: true, class: "descripcionapp", cellClass: "descripcionapp", value: "descripcionapp" }
              , { text: this.$t("view.operativos.campana.form.se.th"), align: "right", sortable: true, class: "se", cellClass: "se", value: "se" }
              , { text: this.$t("view.operativos.campana.form.vendor.th"), align: "left", sortable: true, class: "vendor", cellClass: "vendor", value: "vendor" }
              , { text: this.$t("view.operativos.campana.form.dateres.thini"), align: "left", sortable: true, class: "dateresini", cellClass: "dateresini", value: "dateresini" }
              , { text: this.$t("view.operativos.campana.form.dateres.thend"), align: "left", sortable: true, class: "dateresend", cellClass: "dateresend", value: "dateresend" }
              , { text: this.$t("view.operativos.campana.form.canales.th"), align: "left", sortable: true, class: "canales", cellClass: "canales", value: "canales" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: false, class: "accion", cellClass: "accion", value: "accion" }
            ]
          }
        }
      }
    };
  }
  , computed: {
    selectedcomputed() {
      if (this.selectall) return this.deselected ? this.view.elem.datatable.total - this.deselected.length : this.view.elem.datatable.total;
      return this.selected ? this.selected.length : 0;
    }
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;

      const serverSideDataT = this.prepareData();
      const response = await CampanaAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      if (this.selectall) this.selected = data.filter((item) => this.deselected.filter((i) => i.clave == item.clave));
      this.view.elem.datatable.total = Number(recordsTotal);
      this.refreshkey += 1;

      this.view.elem.datatable.loading = false;
    }
    , async edit(clave) {
      this.$emit("editRow", clave);
    }
    , async disable(clave) {
      if ((await this.$swal(disableSwal)).value) {
        if (handleResponse(await CampanaAPI.disable({ clave }))) {
          this.load();
          if (clave == this.$parent.campana.clave) this.$emit("editRow", clave);
        }
      }
    }
    , async audit(clave, descripcion) {
      this.$emit("auditRow", clave, descripcion);
    }
    , refreshData() {
      this.clearSelection();
      this.load();
    }
    , refreshSearch() {
      this.options.page = 1;
      this.clearSelection();
      this.load();
    }
    , clearSearch() {
      this.search = "";
      this.options.page = 1;
      this.clearSelection();
      this.load();
    }
    , async filter(filters) {
      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          fls[key] = fls[key].join();
        } else {
          delete fls[key];
        }
      });
      this.options.page = 1;
      this.filtros = fls;
      this.clearSelection();
      await this.load();
    }
    , itemSelected({ item, value }) {
      if (value) {
        if (!this.selected.some((i) => i.clave == item.clave)) this.selected.push(item);
        this.deselected = this.deselected.filter((i) => i.clave != item.clave);
      } else {
        this.selected = this.selected.filter((i) => i.clave != item.clave);
        if (!this.deselected.some((i) => i.clave == item.clave)) this.deselected.push(item);
      }
    }
    , toggleSelectAll({ value }) {
      this.selectall = value;
      if (value) {
        this.selected = this.view.elem.datatable.data;
        this.deselected = [];
      } else {
        this.selected = [];
        this.deselected = this.view.elem.datatable.data;
      }
    }
    , clearSelection() {
      this.selectall = false;
      this.selected = [];
      this.deselected = [];
    }
    , massupdate() {
      const filters = { ...this.filtros };

      if (this.view.elem.datatable.total <= 0 || (!this.selectall && this.selected <= 0)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "info", "VL0000", this.$t("view.operativos.campana.massupdate.minregs"));
        return false;
      }

      if ((this.selectall && this.view.elem.datatable.total - this.deselected.length > 2500) || this.selected.length > 2500) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "info", "VL0000", this.$t("view.commons.maxregs"));
        return false;
      }

      if (this.selectall) {
        if (this.deselected && this.deselected.length > 0) filters.deselected = this.deselected.map((i) => i.clave).join(",");
      } else {
        filters.selected = this.selected.map((i) => i.clave).join(",");
      }

      this.$refs.massUpdateModal.open(filters);
    }
    , fixSe
  }
};
</script>

<style>
.campana .canales {
  max-width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.campana .canales div {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/campana/DataTable.vue